import tree from "../../../components/tree.vue"
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import moment from 'moment';
import { domainName } from "../../../utility/index"

export default {
  name: "userManagement",
  components: { tree, iColumn, iTable, IPagination },
  data() {
    return {
      formInline: {
        data: [],
        orgId: '',
      },
      pickerOptions: {
        disabledDate: (time) => {
          const now = new Date();
          const currentMonthFirstDay = new Date(now.getFullYear(), now.getMonth(), 1);
          return time > currentMonthFirstDay;
        }
      },
      orgIdList: [],
      list: [],
      columnList: [],
      tableHeight: '',
      loading: false,
    };
  },
  created() {
    this.getDate()
    this.getOrg()
  },
  mounted() {
    this.getData()

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    getDate() {
      const endTime = moment().subtract(1, "month").format("YYYY-MM");
      const startTime = moment().subtract(6, "month").format("YYYY-MM");
      this.formInline.data = [startTime, endTime];
    },
    getOrg() {
      this.$store.dispatch('tree/GET_SELECTUSERORG').then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.orgIdList = res.data.data
          }
        }
      })
    },
    setClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex <= 2) {
        return 'addBorder'
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2) {
        if (row.description === "数量(台)") {
          if (rowIndex === 0) {
            // 返回合并的行数和列数：合并所有包含"数量(台)"的行
            const sameDescriptionRows = this.list.filter(item => item.description === "数量(台)");
            return {
              rowspan: sameDescriptionRows.length,
              colspan: 1
            };
          } else {
            // 其他行不显示
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      }

    },
    handleResize() {
      const windowHeight = window.innerHeight;
      this.tableHeight = (windowHeight - 300) + 'px';

    },
    getData() {
      this.loading = true
      let param = {
        userId: sessionStorage.getItem("userId"),
        orgId: this.formInline.orgId,
        startTime: this.formInline.data[0],
        endTime: this.formInline.data[1],
      }
      this.$store.dispatch('ReportAnalysis/GET_SELECTCARHOMEWORKTABLE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.columnList = res.data.data.label
            this.loading = false

            this.$nextTick(() => {
              this.$refs.dataTable?.doLayout?.()
            })
          }
        }
      })
    },
    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportLeaseTable?orgId=${this.formInline.orgId}&startTime=${this.formInline.data[0]}&endTime=${this.formInline.data[1]}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportLeaseTable?orgId=${this.formInline.orgId}&startTime=${this.formInline.data[0]}&endTime=${this.formInline.data[1]}&userId=${sessionStorage.getItem("userId")}`
          location.href = url
        }
      }
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    onClear() {
      this.formInline = {
        data: [],
        orgId: '',
      }
      this.getDate()
      this.getData()
    },
  },
};
